export default __webpack_public_path__ + "static/FyranSans-Medium-e50b6e19208684e7fd57636c2606bae4.woff2";